import { render, staticRenderFns } from "./Assays.vue?vue&type=template&id=28355454&scoped=true&"
var script = {}
import style0 from "./Assays.vue?vue&type=style&index=0&id=28355454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28355454",
  null
  
)

export default component.exports